import http from "../utils/HttpUtils";
import WarehouseService from "../pages/base/warehouse/WarehouseService";
import AreaService from "../pages/base/warehouse/AreaService";
import ShelveService from "../pages/base/warehouse/ShelveService";
import PositionService from "../pages/base/warehouse/PositionService";
import SupplierService from "../pages/base/supplier/SupplierService";
import CustomerService from "../pages/base/customer/CustomerService";

//通用字典接口服务
class CmDictService {
    static async getSalePayStatusDict() {
        let dictData = await this.loadDictByCode("019");
        return transListDict(dictData)
    }

    static async getSaleReturnPayStatusDict() {
        let dictData = await this.loadDictByCode("030");
        return transListDict(dictData)
    }

    static async getPurchasePayStatusDict() {
        let dictData = await this.loadDictByCode("026");
        return transListDict(dictData)
    }

    static async getPurchaseReturnPayStatusDict() {
        let dictData = await this.loadDictByCode("028");
        return transListDict(dictData)
    }

    static async loadDictByCode(dictCode) {
        const apiUrl = "/base/dict/findDictsByCode/" + dictCode;
        let retData = await http.get(apiUrl);
        const [{children = [],},] = retData;
        return children;
    }

    //单据状态
    static async getBillsTypeDict() {
        let dictData = await this.loadDictByCode("039");
        return transListDict(dictData)
    }

    //收款状态
    static async getPayeeTypeDict() {
        let dictData = await this.loadDictByCode("035");
        return transListDict(dictData)
    }

    //开户银行类型
    static async getOpnBankDict() {
        let dictData = await this.loadDictByCode("036");
        return transListDict(dictData)
    }

    static async getBrandDict() {
        let dictData = await this.loadDictByCode("032");
        return transListDict(dictData)
    }

    static async getMaterialUnitDict() {
        let dictData = await this.loadDictByCode("033");
        return transListDict(dictData)
    }

    static async getEngineTypeDict() {
        let dictData = await this.loadDictByCode("005");
        return transListDict(dictData)
    }

    static async getMaterialSortDict() {
        let dictData = await this.loadDictByCode("003");
        return transTreeDict(dictData)
    }


    static async getSupplierTypeDict() {
        let dictData = await this.loadDictByCode("002");

        return transListDict(dictData)
    }

    static async getCustomerTypeDict() {
        let dictData = await this.loadDictByCode("001");
        return transTreeDict(dictData)

    }

    static async getPayTypeDict() {
        let dictData = await this.loadDictByCode("008");
        return transListDict(dictData)
    }

    static async getPayStatusDict() {
        //调用销售单的资金状态
        let dictData = await this.loadDictByCode("019");
        return transListDict(dictData)
    }

    static async getWhOutStatusDict() {
        //调用销售单的资金状态
        let dictData = await this.loadDictByCode("018");
        return transListDict(dictData)
    }


    //发票类型字典
    static async getInvoiceTypeDict() {
        let dictData = await this.loadDictByCode("004");
        return transListDict(dictData)
    }

    //销售订单状态字典
    static async getSaleOrderStatusDict() {
        let dictData = await this.loadDictByCode("014");
        return transListDict(dictData)
    }

    //销售单状态字典
    static async getSaleStatusDict() {
        let dictData = await this.loadDictByCode("017");
        return transListDict(dictData)
    }

    //销售退货单状态字典
    static async getSaleReturnStatusDict() {
        let dictData = await this.loadDictByCode("029");
        return transListDict(dictData)
    }

    //采购类型
    static async getPurchaseOrderTypeDict() {
        let dictData = await this.loadDictByCode("007");
        return transListDict(dictData)
    }

    //采购订单状态字典
    static async getPurchaseOrderStatusDict() {
        const retData = {
            dictName: "采购订单状态",
            dictCode: "purchaseOrder",
            children: [
                {dictName: '初始状态', dictCode: '001'},
                {dictName: '禁用状态', dictCode: '002'},
            ]

        }
        return transListDict(retData.children);
    }

    //采购发运单状态字典
    static async getPurchaseInvoiceStatusDict() {
        const retData = {
            dictName: "采购发运单状态",
            dictCode: "purchaseInvoiceStatus",
            children: [
                {dictName: '初始状态', dictCode: '001'},
                {dictName: '禁用状态', dictCode: '002'},
            ]

        }
        return transListDict(retData.children);
    }

    //入库状态
    static async getWhInStatusDict() {
        const retData = {
            dictName: "入库状态",
            dictCode: "whInStatus",
            children: [
                {dictName: '未入库', dictCode: '001'},
                {dictName: '部分入库', dictCode: '002'},
                {dictName: '已入库', dictCode: '003'},
            ]

        }
        return transListDict(retData.children);
    }

    //采购单状态字典
    static async getPurchaseStatusDict() {
        let dictData = await this.loadDictByCode("025");
        return transListDict(dictData)
    }

    //采购退货单状态字典
    static async getPurchaseReturnStatusDict() {
        let dictData = await this.loadDictByCode("027");
        return transListDict(dictData)
    }

    //销售订单类型
    static async getSaleOrderTypeDict() {
        let dictData = await this.loadDictByCode("015");
        return transListDict(dictData)

    }

    //销售价格类型
    static async getSalePriceTypeDict() {
        let dictData = await this.loadDictByCode("038");
        return transListDict(dictData)

    }

    //盘点状态
    static async getStockCheckStatusDict() {
        let dictData = await this.loadDictByCode("031");
        return transListDict(dictData)
    }

    //盘点结果
    static getCheckResultDict() {
        return [
            {key: -1, value: -1, label: "盘亏"},
            {key: 0, value: 0, label: "相符"},
            {key: 1, value: 1, label: "盘盈"},
        ]
    }

    //设置账户类型  郝磊
    static async getAccountTypeDict() {
        let dictData = await this.loadDictByCode("009");
        // console.log(dictData)
        return transListDict(dictData);
    }

    static async getOrgDict() {
        let dictData = await this.loadDictByCode("042");
        return transTreeDict(dictData);
        /*const retData = {
            dictName: "组织机构",
            dictCode: "org",
            children: [
                {
                    dictName: '机构1',
                    dictCode: '001',
                    children: [
                        {dictName: '机构11', dictCode: '001001'},
                        {dictName: '机构12', dictCode: '001002'}
                    ]
                },
                {
                    dictName: '机构2',
                    dictCode: '002',
                    children: [
                        {dictName: '机构21', dictCode: '002001'},
                        {dictName: '机构22', dictCode: '002002'}
                    ]
                }
            ]

        }
        return transTreeDict(retData.children);*/
    }

    static async getWarehouseDict() {
        /*const dataList = [
            {id: '001', orgId: '001', warehouseCode: '001', warehouseName: '仓库001'},
            {id: '002', orgId: '002', warehouseCode: '002', warehouseName: '仓库002'},
        ]*/
        const {list: dataList} = await WarehouseService.findPage({pageSize: 100, pageNum: 1});
        return dataList.map(el => {
            const {id, orgId, warehouseCode, warehouseName} = el
            return {
                key: id,
                value: id,
                label: warehouseName,
                warehouseCode,
                orgId,
            }
        });
    }

    static async getAreaDict() {
        /*const dataList = [
            {id: '001', orgId: '001', warehouseId: '001', areaCode: '001'},
            {id: '002', orgId: '001', warehouseId: '001', areaCode: '002'},
            {id: '003', orgId: '002', warehouseId: '002', areaCode: '003'},
        ]*/
        const {list: dataList} = await AreaService.findPage({pageSize: 100, pageNum: 1});
        return dataList.map(el => {
            const {id, orgId, warehouseId, areaCode} = el
            return {
                key: id,
                value: id,
                label: areaCode,
                orgId,
                warehouseId,
            }
        });
    }

    static async getShelveDict() {
        /*const dataList = [
            {id: '001', orgId: '001', warehouseId: '001', areaId: "001", shelvesCode: '001'},
            {id: '002', orgId: '001', warehouseId: '001', areaId: '001', shelvesCode: "002"},
            {id: '003', orgId: '001', warehouseId: '001', areaId: '001', shelvesCode: "003"},
        ]*/
        const {list: dataList} = await ShelveService.findPage({pageSize: 500, pageNum: 1});
        return dataList.map(el => {
            const {id, orgId, warehouseId, areaId, areaCode, shelvesCode} = el
            return {
                key: id,
                value: id,
                label: areaCode + "-" + shelvesCode,
                orgId,
                warehouseId,
                areaId
            }
        });
    }

    static async getPositionDict() {
        /*const dataList = [
            {id: '001', orgId: '001', warehouseId: '001', areaId: "001", shelvesId: "001", shelfCode: '001'},
            {id: '002', orgId: '001', warehouseId: '001', areaId: '001', shelvesId: "001", shelfCode: "002"},
            {id: '003', orgId: '001', warehouseId: '001', areaId: '001', shelvesId: "001", shelfCode: "003"},
        ]*/
        const {list: dataList} = await PositionService.findPage({pageSize: 1000, pageNum: 1});
        return dataList.map(el => {
            const {id, orgId, warehouseId, areaId, shelvesId, shelfCode} = el
            return {
                key: id,
                value: id,
                label: shelfCode,
                orgId,
                warehouseId,
                areaId,
                shelvesId
            }
        });
    }

    static async getSupplierDict() {
        const {list: dataList} = await SupplierService.findPage({pageSize: 1000, pageNum: 1});
        return dataList
            .filter(el => el.supplierStatus !== 1)
            .map(el => {
                const {id, supplierName} = el
                return {
                    key: id,
                    value: id,
                    label: supplierName,
                }
            });
        /*return dataList.map(el => {
            const {id, supplierName} = el
            return {
                key: id,
                value: id,
                label: supplierName,
            }
        });*/

        /*const retData = {
            dictCode: 'supplier',
            dictName: '供应商编码',
            children: [{dictName: '供应商1', dictCode: '001'}, {dictName: '供应商2', dictCode: '002'}]
        };
        return transListDict(retData.children);*/
    }

    static async getCustomerDict() {
        const {list: dataList} = await CustomerService.findPage({pageSize: 9000, pageNum: 1});
        return dataList
            .filter(el => el.customerStatus !== 1)
            .map(el => {
                const {id, customerName} = el
                return {
                    key: id,
                    value: id,
                    label: customerName,
                }
            });
        /*return dataList.map(el => {
            const {id, customerName} = el
            return {
                key: id,
                value: id,
                label: customerName,
            }
        });*/
        /*const retData = {
            dictCode: 'customer',
            dictName: '客户编码',
            children: [{dictName: '客户1', dictCode: '001'}, {dictName: '客户2', dictCode: '002'}]
        };
        return transListDict(retData.children);*/
    }
}

function transListDict(dictList) {
    return !!dictList ? dictList.map(el => ({
        key: el.dictCode,
        label: el.dictName,
        value: el.dictCode,
    })) : [];
}

function transTreeDict(dictList) {
    return !!dictList ? dictList.map(el => {
        let tmpDict = {
            title: el.dictName,
            value: el.dictCode,
            key: el.dictCode
        }
        if (!!el.children && el.children.length > 0) {
            tmpDict.children = transTreeDict(el.children);
        }
        return tmpDict;
    }) : [];
}

export default CmDictService;